import { render } from "./ComingView.vue?vue&type=template&id=0e2bb210"
import script from "./ComingView.vue?vue&type=script&lang=js"
export * from "./ComingView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__